import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="This page lets you configure which <strong>products</strong> and <strong>resources</strong> are included in a license." id="this_page_lets_you_configure_which_produ.bc400b3e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Managing Content" id="managing_content.b0669f4d" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the available controls to <strong>add</strong> new products to a license or <strong>remove</strong> existing ones. Changes affect all future activations of the license." id="use_the_available_controls_to_add_new_pr.b5e8301b" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Adding or Removing Products" id="adding_or_removing_products.4e1b67ec" />
        }
    ],
    title: <FormattedMessage defaultMessage="License Content Management" id="license_content_management.859722ec" />
};
